'use client';
"use strict";

var _excluded = ["size", "isIndeterminate"],
    _excluded2 = ["size", "max", "min", "valueText", "getValueText", "value", "capIsRound", "children", "thickness", "color", "trackColor", "isIndeterminate"],
    _excluded3 = ["min", "max", "value", "isIndeterminate", "role"],
    _excluded4 = ["value", "min", "max", "hasStripe", "isAnimated", "children", "borderRadius", "isIndeterminate", "aria-label", "aria-labelledby", "aria-valuetext", "title", "role"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  CircularProgress: function CircularProgress() {
    return _CircularProgress;
  },
  CircularProgressLabel: function CircularProgressLabel() {
    return _CircularProgressLabel;
  },
  Progress: function Progress() {
    return _Progress;
  },
  ProgressLabel: function ProgressLabel() {
    return _ProgressLabel;
  },
  useProgressStyles: function useProgressStyles() {
    return _useProgressStyles;
  }
});

module.exports = __toCommonJS(src_exports); // src/circular-progress.tsx

var import_system4 = require("@chakra-ui/system"); // src/progress.utils.tsx


var import_system = require("@chakra-ui/system");

function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}

var spin = (0, import_system.keyframes)({
  "0%": {
    strokeDasharray: "1, 400",
    strokeDashoffset: "0"
  },
  "50%": {
    strokeDasharray: "400, 400",
    strokeDashoffset: "-100"
  },
  "100%": {
    strokeDasharray: "400, 400",
    strokeDashoffset: "-260"
  }
});
var rotate = (0, import_system.keyframes)({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var progress = (0, import_system.keyframes)({
  "0%": {
    left: "-40%"
  },
  "100%": {
    left: "100%"
  }
});
var stripe = (0, import_system.keyframes)({
  from: {
    backgroundPosition: "1rem 0"
  },
  to: {
    backgroundPosition: "0 0"
  }
});

function getProgressProps(options) {
  var _options$value = options.value,
      value = _options$value === void 0 ? 0 : _options$value,
      min = options.min,
      max = options.max,
      valueText = options.valueText,
      getValueText = options.getValueText,
      isIndeterminate = options.isIndeterminate,
      _options$role = options.role,
      role = _options$role === void 0 ? "progressbar" : _options$role;
  var percent = valueToPercent(value, min, max);

  var getAriaValueText = function getAriaValueText() {
    if (value == null) return void 0;
    return typeof getValueText === "function" ? getValueText(value, percent) : valueText;
  };

  return {
    bind: {
      "data-indeterminate": isIndeterminate ? "" : void 0,
      "aria-valuemax": max,
      "aria-valuemin": min,
      "aria-valuenow": isIndeterminate ? void 0 : value,
      "aria-valuetext": getAriaValueText(),
      role: role
    },
    percent: percent,
    value: value
  };
} // src/shape.tsx


var import_system2 = require("@chakra-ui/system");

var import_jsx_runtime = require("react/jsx-runtime");

var Shape = function Shape(props) {
  var size = props.size,
      isIndeterminate = props.isIndeterminate,
      rest = _objectWithoutProperties(props, _excluded);

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system2.chakra.svg, _objectSpread({
    viewBox: "0 0 100 100",
    __css: {
      width: size,
      height: size,
      animation: isIndeterminate ? "".concat(rotate, " 2s linear infinite") : void 0
    }
  }, rest));
};

Shape.displayName = "Shape"; // src/circle.tsx

var import_system3 = require("@chakra-ui/system");

var import_jsx_runtime2 = require("react/jsx-runtime");

var Circle = function Circle(props) {
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system3.chakra.circle, _objectSpread({
    cx: 50,
    cy: 50,
    r: 42,
    fill: "transparent"
  }, props));
};

Circle.displayName = "Circle"; // src/circular-progress.tsx

var import_jsx_runtime3 = require("react/jsx-runtime");

var _CircularProgress = (0, import_system4.forwardRef)(function (props, ref) {
  var _a;

  var _props$size = props.size,
      size = _props$size === void 0 ? "48px" : _props$size,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      valueText = props.valueText,
      getValueText = props.getValueText,
      value = props.value,
      capIsRound = props.capIsRound,
      children = props.children,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? "10px" : _props$thickness,
      _props$color = props.color,
      color = _props$color === void 0 ? "#0078d4" : _props$color,
      _props$trackColor = props.trackColor,
      trackColor = _props$trackColor === void 0 ? "#edebe9" : _props$trackColor,
      isIndeterminate = props.isIndeterminate,
      rest = _objectWithoutProperties(props, _excluded2);

  var progress2 = getProgressProps({
    min: min,
    max: max,
    value: value,
    valueText: valueText,
    getValueText: getValueText,
    isIndeterminate: isIndeterminate
  });
  var determinant = isIndeterminate ? void 0 : ((_a = progress2.percent) != null ? _a : 0) * 2.64;
  var strokeDasharray = determinant == null ? void 0 : "".concat(determinant, " ").concat(264 - determinant);
  var indicatorProps = isIndeterminate ? {
    css: {
      animation: "".concat(spin, " 1.5s linear infinite")
    }
  } : {
    strokeDashoffset: 66,
    strokeDasharray: strokeDasharray,
    transitionProperty: "stroke-dasharray, stroke",
    transitionDuration: "0.6s",
    transitionTimingFunction: "ease"
  };
  var rootStyles = {
    display: "inline-block",
    position: "relative",
    verticalAlign: "middle",
    fontSize: size
  };
  return /* @__PURE__ */(0, import_jsx_runtime3.jsxs)(import_system4.chakra.div, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: "chakra-progress"
  }, progress2.bind), rest), {}, {
    __css: rootStyles,
    children: [/* @__PURE__ */(0, import_jsx_runtime3.jsxs)(Shape, {
      size: size,
      isIndeterminate: isIndeterminate,
      children: [/* @__PURE__ */(0, import_jsx_runtime3.jsx)(Circle, {
        stroke: trackColor,
        strokeWidth: thickness,
        className: "chakra-progress__track"
      }), /* @__PURE__ */(0, import_jsx_runtime3.jsx)(Circle, _objectSpread({
        stroke: color,
        strokeWidth: thickness,
        className: "chakra-progress__indicator",
        strokeLinecap: capIsRound ? "round" : void 0,
        opacity: progress2.value === 0 && !isIndeterminate ? 0 : void 0
      }, indicatorProps))]
    }), children]
  }));
});

_CircularProgress.displayName = "CircularProgress"; // src/progress.tsx

var import_system5 = require("@chakra-ui/system");

var import_react_context = require("@chakra-ui/react-context");

var import_jsx_runtime4 = require("react/jsx-runtime");

var _ref = (0, import_react_context.createContext)({
  name: "ProgressStylesContext",
  errorMessage: "useProgressStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Progress />\" "
}),
    _ref2 = _slicedToArray(_ref, 2),
    ProgressStylesProvider = _ref2[0],
    _useProgressStyles = _ref2[1];

var ProgressFilledTrack = (0, import_system5.forwardRef)(function (props, ref) {
  var min = props.min,
      max = props.max,
      value = props.value,
      isIndeterminate = props.isIndeterminate,
      role = props.role,
      rest = _objectWithoutProperties(props, _excluded3);

  var progress2 = getProgressProps({
    value: value,
    min: min,
    max: max,
    isIndeterminate: isIndeterminate,
    role: role
  });

  var styles = _useProgressStyles();

  var trackStyles = _objectSpread({
    height: "100%"
  }, styles.filledTrack);

  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system5.chakra.div, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    style: _objectSpread({
      width: "".concat(progress2.percent, "%")
    }, rest.style)
  }, progress2.bind), rest), {}, {
    __css: trackStyles
  }));
});

var _Progress = (0, import_system5.forwardRef)(function (props, ref) {
  var _a;

  var _ref3 = (0, import_system5.omitThemingProps)(props),
      value = _ref3.value,
      _ref3$min = _ref3.min,
      min = _ref3$min === void 0 ? 0 : _ref3$min,
      _ref3$max = _ref3.max,
      max = _ref3$max === void 0 ? 100 : _ref3$max,
      hasStripe = _ref3.hasStripe,
      isAnimated = _ref3.isAnimated,
      children = _ref3.children,
      propBorderRadius = _ref3.borderRadius,
      isIndeterminate = _ref3.isIndeterminate,
      ariaLabel = _ref3["aria-label"],
      ariaLabelledBy = _ref3["aria-labelledby"],
      ariaValueText = _ref3["aria-valuetext"],
      title = _ref3.title,
      role = _ref3.role,
      rest = _objectWithoutProperties(_ref3, _excluded4);

  var styles = (0, import_system5.useMultiStyleConfig)("Progress", props);
  var borderRadius = propBorderRadius != null ? propBorderRadius : (_a = styles.track) == null ? void 0 : _a.borderRadius;
  var stripeAnimation = {
    animation: "".concat(stripe, " 1s linear infinite")
  };
  var shouldAddStripe = !isIndeterminate && hasStripe;
  var shouldAnimateStripe = shouldAddStripe && isAnimated;

  var css = _objectSpread(_objectSpread({}, shouldAnimateStripe && stripeAnimation), isIndeterminate && {
    position: "absolute",
    willChange: "left",
    minWidth: "50%",
    animation: "".concat(progress, " 1s ease infinite normal none running")
  });

  var trackStyles = _objectSpread({
    overflow: "hidden",
    position: "relative"
  }, styles.track);

  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system5.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    borderRadius: borderRadius,
    __css: trackStyles
  }, rest), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime4.jsxs)(ProgressStylesProvider, {
      value: styles,
      children: [/* @__PURE__ */(0, import_jsx_runtime4.jsx)(ProgressFilledTrack, {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-valuetext": ariaValueText,
        min: min,
        max: max,
        value: value,
        isIndeterminate: isIndeterminate,
        css: css,
        borderRadius: borderRadius,
        title: title,
        role: role
      }), children]
    })
  }));
});

_Progress.displayName = "Progress"; // src/progress-label.tsx

var import_system6 = require("@chakra-ui/system");

var import_jsx_runtime5 = require("react/jsx-runtime");

var _ProgressLabel = function _ProgressLabel(props) {
  var styles = _useProgressStyles();

  var labelStyles = _objectSpread({
    top: "50%",
    left: "50%",
    width: "100%",
    textAlign: "center",
    position: "absolute",
    transform: "translate(-50%, -50%)"
  }, styles.label);

  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_system6.chakra.div, _objectSpread(_objectSpread({}, props), {}, {
    __css: labelStyles
  }));
};

_ProgressLabel.displayName = "ProgressLabel"; // src/circular-progress-label.tsx

var import_system7 = require("@chakra-ui/system");

var _CircularProgressLabel = (0, import_system7.chakra)("div", {
  baseStyle: {
    fontSize: "0.24em",
    top: "50%",
    left: "50%",
    width: "100%",
    textAlign: "center",
    position: "absolute",
    transform: "translate(-50%, -50%)"
  }
});

_CircularProgressLabel.displayName = "CircularProgressLabel"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  CircularProgress: _CircularProgress,
  CircularProgressLabel: _CircularProgressLabel,
  Progress: _Progress,
  ProgressLabel: _ProgressLabel,
  useProgressStyles: _useProgressStyles
});